// extracted by mini-css-extract-plugin
module.exports = {"averageDonationBanner":"jgp-3O3_4","donateIcon":"jgp-1lHId","averageDonationAmount":"jgp-3MXDE"};